// extracted by mini-css-extract-plugin
module.exports = {"icon":"hamburger_icon__2YByy","open":"hamburger_open__39F2I"};